/**
 * @generated SignedSource<<82350daae2c2942b03bd32679823d7a1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type selfServicePageQuery$variables = {
  ujId: number;
};
export type selfServicePageQuery$data = {
  readonly currentUser: {
    readonly isAdmin: boolean;
  };
  readonly userJourney: {
    readonly isSelfService: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"selfServiceSettings_mainSettingsFragment" | "selfServiceStatus_statusFragment">;
  };
};
export type selfServicePageQuery = {
  response: selfServicePageQuery$data;
  variables: selfServicePageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ujId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAdmin",
  "storageKey": null
},
v2 = [
  {
    "kind": "Variable",
    "name": "ujId",
    "variableName": "ujId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSelfService",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "selfServicePageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "UserJourney",
        "kind": "LinkedField",
        "name": "userJourney",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "selfServiceSettings_mainSettingsFragment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "selfServiceStatus_statusFragment"
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "selfServicePageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "UserJourney",
        "kind": "LinkedField",
        "name": "userJourney",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cutoff",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cutOffOK",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "alertOnSlow",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "journeyScribeStartingDomain",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "journeyScribeStartingDomainLocked",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "journeyScribeStartingURL",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "journeyScribeStartingURL",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "journeyScribeStartingURL",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "journeyScribeJourneyType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4a17f61d81267493186f3a05873276ee",
    "id": null,
    "metadata": {},
    "name": "selfServicePageQuery",
    "operationKind": "query",
    "text": "query selfServicePageQuery(\n  $ujId: Int!\n) {\n  currentUser {\n    isAdmin\n    id\n  }\n  userJourney(ujId: $ujId) {\n    ...selfServiceSettings_mainSettingsFragment\n    ...selfServiceStatus_statusFragment\n    isSelfService\n    id\n  }\n}\n\nfragment selfServiceSettings_mainSettingsFragment on UserJourney {\n  id\n  name\n  cutoff\n  cutOffOK\n  alertOnSlow\n  journeyScribeStartingDomain\n  journeyScribeStartingDomainLocked\n  journeyScribeStartingURL\n  journeyScribeJourneyType\n}\n\nfragment selfServiceStatus_statusFragment on UserJourney {\n  id\n  status\n}\n"
  }
};
})();

(node as any).hash = "25c29f111bc2304f3aaead8c3f1638fc";

export default node;
